import { useEffect, useLayoutEffect } from 'react';

import Router from 'next/router';

import { useChatGPTContext } from '@contexts/chatGPT';
import { useSkipEffectOnMount } from '@hooks/lifecycle';

export const useSetChatGPTMessage = (message: string) => {
  const { setChatGPTMessage } = useChatGPTContext();

  useEffect(() => {
    if (!message) return;

    setChatGPTMessage(message);
  }, [message, setChatGPTMessage]);
};

export const useHandleOnRedirection = (exitingFunction: () => void) => {
  useSkipEffectOnMount(() => {
    Router.events.on('routeChangeStart', exitingFunction);

    return () => {
      Router.events.off('routeChangeStart', exitingFunction);
    };
  }, [Router.events, exitingFunction]);
};

export const useHideChatGPT = (condition: boolean) => {
  const { changeChatGPTVisibility } = useChatGPTContext();

  useLayoutEffect(() => {
    if (condition) return changeChatGPTVisibility(false);

    changeChatGPTVisibility(true);
  }, [condition]);
};
